import type {
	JSX,
} from 'react'

import {
	useTelegramViewport,
} from '@/shared/lib/hooks'

import type {
	IViewportProviderProps,
} from './viewport-provider.types'

/**
 * Provider that initializes Telegram viewport and binds safe area CSS variables.
 *
 * This provider should be placed early in the component tree to ensure
 * CSS variables are available for all child components.
 */
export const ViewportProvider = ({
	children,
}: IViewportProviderProps): JSX.Element => {
	useTelegramViewport()

	return (
		<>
			{children}
		</>
	)
}
